import { FormularioDinamicoRuntime } from '../../type/FormularioDinamico';
import { mesmoConteudo } from './formularioValores';

export const SITUACOES = {
  INVALIDO: { rotulo: 'Com pendências', cor: 'negative' },
  PENDENTE: { rotulo: 'Pendente', cor: 'negative' },
  ALTERADO: { rotulo: 'Pronto para salvar', cor: 'warning' },
  SALVO: { rotulo: 'Salvo', cor: 'positive' }
} as const;

export type Situacao = typeof SITUACOES[keyof typeof SITUACOES];

export const situacaoDe = (
  formulario: FormularioDinamicoRuntime,
  valores: Record<string, Record<string, unknown>>,
  persistidos: Record<string, Record<string, unknown>>,
  invalido?: boolean
): Situacao => {
  if (invalido) {
    return SITUACOES.INVALIDO;
  }

  const gravado = persistidos[formulario.id] ?? {};
  const naTela = valores[formulario.id] ?? gravado;

  if (!mesmoConteudo(naTela, gravado)) {
    return SITUACOES.ALTERADO;
  }

  return formulario.status === 'PREENCHIDO'
    ? SITUACOES.SALVO
    : SITUACOES.PENDENTE;
};
